export default __webpack_public_path__ + "static/media/slide02.007bdde8.jpg";